class CouponList extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.loadCoupons();
    }
    loadCoupons() {
        fetch('https://api.lens-labo.com/Api/Shopify/v1/GetDiscounts?shopCD=31&action=list&first=10&query=status:ACTIVE')
            .then(response => response.json())
            .then(data => {
                const coupons = data.DISCOUNTS.map(node => node.discount)
                console.log(coupons)
                coupons.filter(coupon => coupon.__typename != "DiscountCodeApp").forEach(coupon => {
                    const code = coupon.codes ? coupon.codes.edges[0].node.code : '';
                    const endsAt = coupon.endsAt != null ? new Date(coupon.endsAt).toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }) : null;
                    const card = document.createElement('div');
                    card.className = 'coupon-card';
                    card.innerHTML = `
                        
                            <div class="text-container">
                            <div class="text">${coupon.title}</div>
                            </div>
                            <div class="expire-container">
                            ${endsAt != null ? `
                            <div class="expire">
                                <span class="title">有効期限</span>
                                <span class="value">${endsAt}</span>
                            </div>`: ''}
                            ${code != '' ? `<div class="coupon-code">${code}</div>` : ''}
                            </div>
                            <div class="info-container">
                            <div class="info-title">特典</div>
                            <div class="info-content">対象のブランド金額の合計より${coupon.customerGets?.value?.amount ? coupon.customerGets?.value?.amount.amount + '円': coupon.customerGets?.value?.percentage * 100 + '%'}引き</div>
                            </div>
                            ${coupon.minimumRequirement != null ? `
                                <div class="info-container">
                                    <div class="info-title">利用条件</div>
                                    <div class="info-content">
                                        ${coupon.minimumRequirement?.greaterThanOrEqualToSubtotal != null ? coupon.minimumRequirement.greaterThanOrEqualToSubtotal?.amount + '円以上のご購入時に利用可能<br>' : ''}
                                        ${coupon.minimumRequirement?.greaterThanOrEqualToQuantity != null ? coupon.minimumRequirement.greaterThanOrEqualToQuantity + '点以上の商品をご注文の場合に適用されます。<br>' : ''}
                                        会員様限定<br>
                                    </div>
                                </div>
                                `: ''}
                    `;
                    this.appendChild(card);
                });
            })
            .catch(error => {
                console.error('Error fetching coupons:', error);
            });
    }
}
customElements.define('coupon-list', CouponList);